const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();


// ------------------------------------------------------------------------
// storySlider
// ----- BOTH
// ------------------------------------------------------------------------
const storySlider = () => {
  $(".gallery-list").each(function(i) {
    $(this).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      dots: true,
      speed: 500,
      cssEase: 'ease',
      variableWidth: true,
      appendArrows: '#slideNav_Wrap-'+i,
      appendDots: '#slideNav_Dots-'+i,
      responsive: [
         {
           breakpoint: 768,
           settings: {
             slidesToShow: 1,
             swipeToSlide: true,
             swipe: true,
             edgeFriction: 0.01,
           }
         }
       ]
    });
  });
};

// ------------------------------------------------------------------------
// storyAnchor
// ----- BOTH
// ------------------------------------------------------------------------
const storyAnchor = () => {
  $(window).on('load',function() {
    // 追従メニューの出現タイミング調整
    let listHeight = $(".anm-Stories").outerHeight() -  windowHeight / 2;
    // 開始位置から終了位置までの距離計算
    let area01Height = $("#ep-10").outerHeight() + $("#ep-10").offset().top - $("#ep-01").offset().top;
    let area02Height = $("#ep-20").outerHeight() + $("#ep-20").offset().top - $("#ep-11").offset().top;
    let area03Height = $("#ep-30").outerHeight() + $("#ep-30").offset().top - $("#ep-21").offset().top;
    let area04Height = $("#ep-39").outerHeight() + $("#ep-39").offset().top - $("#ep-31").offset().top;
    let area05Height = $("#ep-48").outerHeight() + $("#ep-48").offset().top - $("#ep-41").offset().top;
    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({triggerElement: "#ep-01", duration: listHeight})
            .setClassToggle(".anm-Stories_Anchor_Fixed", "visible")
            .addTo(controller);
    new ScrollMagic.Scene({triggerElement: "#ep-01", duration: area01Height})
            .setClassToggle("#anchor-item-01", "current")
            .addTo(controller);
    new ScrollMagic.Scene({triggerElement: "#ep-11", duration: area02Height})
            .setClassToggle("#anchor-item-02", "current")
            .addTo(controller);
    new ScrollMagic.Scene({triggerElement: "#ep-21", duration: area03Height})
            .setClassToggle("#anchor-item-03", "current")
            .addTo(controller);
    new ScrollMagic.Scene({triggerElement: "#ep-31", duration: area04Height})
            .setClassToggle("#anchor-item-04", "current")
            .addTo(controller);
    new ScrollMagic.Scene({triggerElement: "#ep-41", duration: area04Height})
            .setClassToggle("#anchor-item-05", "current")
            .addTo(controller);
  });
};

// ------------------------------------------------------------------------
// standAnime
// ----- BOTH
// ------------------------------------------------------------------------
const standAnime = () => {
  $(window).on('scroll load', function () {
    $('.stand-anm').each(function () {
      let targetPos = $(this).offset().top;
      let scrollPos = $(window).scrollTop();
      let windowHeight = $(window).height();
      if (scrollPos > targetPos - windowHeight + windowHeight / 2) {
        $(this).addClass("animated")
      }
    });
  });
};

export {
  storySlider,
  storyAnchor,
  standAnime
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js